import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import { ErrorBoundary } from '@bluedolphin/ui';
import Root from './root.component';

const lifecycles = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: Root,
    errorBoundary: ErrorBoundary,
    domElementGetter() {
        const id = '@bluedolphin/auth-mf';
        let container = document.getElementById('@bluedolphin/auth-mf');
        if (!container) {
            container = document.createElement('div');
            container.id = id;
            document.body.prepend(container);
        }
        return container;
    },
});

export const { bootstrap, mount, unmount } = lifecycles;
